import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaGlobe } from "react-icons/fa";

export default function AutomationHttpNode({ data, selected }) {
  return (
    <div className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[220px] transition-shadow ${selected ? "border-cyan-500 shadow-md" : "border-surface-border"}`}>
      <Handle type="target" position={Position.Top} className="!w-3 !h-3 !bg-cyan-500 !border-2 !border-white" />
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px]" style={{ background: "linear-gradient(135deg, #0891b2, #06b6d4)" }}>
        <FaGlobe size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">HTTP Request</span>
      </div>
      <div className="px-3 py-2.5">
        {data.url ? (
          <>
            <p className="text-xs text-ink-primary font-medium">{data.method || "POST"}</p>
            <p className="text-2xs text-ink-muted line-clamp-1 mt-0.5">{data.url}</p>
          </>
        ) : (
          <p className="text-xs text-ink-muted italic">Configure request...</p>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} className="!w-3 !h-3 !bg-cyan-500 !border-2 !border-white" />
    </div>
  );
}
